export class Styling {
    public static readonly smStart = 576;
    public static readonly mdStart = 768;
    public static readonly lgStart = 992;
    public static readonly xlStart = 1200;
    public static readonly NavBarHeight = 55;
    public static readonly TableColumn_RowCounterWidth = '4.5rem';
    public static readonly TableColumn_TightWidth = '1px';
}

export class SpinnerStyle {
    public static readonly compass = 'compass';
    public static readonly default = 'default';
    public static readonly greenRings = 'greenRings';
    public static readonly fadingRing = 'fadingRing';
}
